/**
 * Features whose UI is built but hidden until the API side exists.
 *
 * whatsappConnection: the per-restaurant WhatsApp Business connection
 * (Paramètres → Intégrations, `WhatsAppCard`, `whatsapp.api.ts`) calls
 * `/api/whatsapp/connection`, which `scanifood_api` does not have: the API
 * sends every WhatsApp message from one global sender. Product decision
 * 2026-10-21: hide the UI, keep the code (SFRESTO-154).
 */
export const FEATURE_FLAGS = {
  whatsappConnection: false,
};

export type FeatureFlags = typeof FEATURE_FLAGS;

/** The Intégrations settings tab has something to show. */
export const hasVisibleIntegrations = (
  flags: FeatureFlags = FEATURE_FLAGS
): boolean => flags.whatsappConnection;
